import { AVIS_INICIALITZAR, AVIS_INTRODUCCIO_MODIFICAR_METEOR,
    AVIS_OMPLIR_FORMULARI_AMB_UN_AVIS } from '../../../../actions/actionTypes';

export const ESTAT_INICIAL = null;

const idMeteorSeleccionat = (state = ESTAT_INICIAL, action) => {
    switch (action.type) {

        case AVIS_INICIALITZAR:
            return ESTAT_INICIAL;

        case AVIS_INTRODUCCIO_MODIFICAR_METEOR: {
            const { idMeteorSeleccionat } = action;
            if (idMeteorSeleccionat === undefined) {
                return ESTAT_INICIAL;
            } else {
                return idMeteorSeleccionat;
            }
        }

        case AVIS_OMPLIR_FORMULARI_AMB_UN_AVIS:
            return action.avis.idMeteor;

        default:
            return state;
    }
};

export default idMeteorSeleccionat;



// WEBPACK FOOTER //
// ./src/reducers/avis/formulari/dades/idMeteorSeleccionat.js